/**
 * The public set-password page's two calls (backend-node lib/password-link.js). The link's token
 * authenticates them; no session is needed, so a 401 is never the answer and the app's sign-out
 * handler stays out of it.
 */
import { api } from '@/api/client'

export const SET_PASSWORD_PATH = '/set-password'

export interface PasswordLinkInfo {
    name: string | null
    email: string
    tenant: { name: string; slug: string }
    expires_at: string
    min_length: number
}

export async function fetchPasswordLink(token: string, signal?: AbortSignal): Promise<PasswordLinkInfo> {
    const response = await api.get<{ success: boolean; data: PasswordLinkInfo }>(`/api/auth/password-link?token=${encodeURIComponent(token)}`, { signal, handleUnauthorized: false })
    return response.data
}

export async function setPasswordWithLink(token: string, password: string): Promise<void> {
    await api.post('/api/auth/password-link', { token, password }, { handleUnauthorized: false })
}
